import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  AppBar,
  Tabs,
  Tab,
  IconButton,
  TextField,
  CircularProgress,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import TabPanel from '../../components/TabPanel';
import { fetchPatientById } from '../../services/api';

const ConsultNotesViewModal = props => {
  const {
    patientId,
    open,
    onClose,
    loading,
    classes: { modal, modalContent, submitButton, actions, input },
  } = props;
  const [patientInfo, setPatientInfo] = React.useState({});
  React.useEffect(() => {
    (async () => {
      const patientInfo = await fetchPatientById(patientId);
      setPatientInfo(patientInfo);
      props.setLoading(false);
    })();
  }, []);
  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onClose}
      classes={{ paper: props.classes.modal }}
    >
      <>
        <DialogTitle>
          <Grid container alignItems="center">
            <Grid item xs={11}>
              <h2>Patient Details</h2>
            </Grid>
            <Grid item xs={1}>
              <IconButton aria-label="Close" onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Grid>{' '}
          </Grid>
        </DialogTitle>
        {loading ?<div className={props.classes.loading}><CircularProgress/></div>:
        <TabPanel>
          <TextField
            disabled
            fullWidth
            variant="outlined"
            label="Name"
            name="name"
            value={patientInfo.name}
            className={props.classes.input}
          />

          <TextField
            disabled
            fullWidth
            variant="outlined"
            label="Email"
            name="email"
            value={patientInfo.email}
            className={props.classes.input}
          />

          <TextField
            disabled
            fullWidth
            variant="outlined"
            label="Phone Number"
            name="phone"
            value={patientInfo.phone}
            className={props.classes.input}
          />

          <TextField
            disabled
            fullWidth
            variant="outlined"
            label="Birthdate"
            name="birthdate"
            value={patientInfo.birthdate}
            className={props.classes.input}
          />

          <TextField
            disabled
            fullWidth
            variant="outlined"
            label="Insurance Name"
            name="insuranceName"
            value={patientInfo.insuranceName}
            className={props.classes.input}
          />

          <TextField
            disabled
            fullWidth
            variant="outlined"
            label="Insurance ID"
            name="insuranceId"
            value={patientInfo.insuranceId}
            className={props.classes.input}
          />
        </TabPanel>}
      </>
    </Dialog>
  );
};

const styles = () => ({
  modal: {
    maxHeight: '700px',
  },
  modalContent: {
    overflow: 'visible',
  },
  actions: {
    marginTop: '1em',
    float: 'right',
  },
  input: {
    margin: '0.5em 0',
  },
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

ConsultNotesViewModal.propTypes = {
  patientInfo: PropTypes.object,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles)(ConsultNotesViewModal);
